import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-new-pallet-type',
  templateUrl: './new-pallet-type.component.html',
  styleUrls: ['./new-pallet-type.component.scss'],
})
export class NewPalletTypeComponent {
  headerData: any;
  headerName = '';
  modalLabel: any;
  palletTypeData: any;
  palletTypeAddEditForm!: FormGroup;
  submitted = false;
  activatedRoute: any;
  materialList: any;
  selectOrganization: any;
  organizationlist: any;
  isDisableDropDown!: boolean;
  @Output() saveNewPalletTypeEvent = new EventEmitter<any>();

  constructor(private formBuilder: FormBuilder, private modal: CustomModalService) {
    this.activatedRoute = this.modal?.modalService?.config?.initialState?.['pathName'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.palletTypeData = this.modal?.modalService?.config?.initialState?.['newPalletTypeData'];
    const placeHolderOrganization = {
      name: 'All organization',
    };
    const newOrganizationlist = [placeHolderOrganization].concat(
      this.palletTypeData.organizationList
    );

    this.organizationlist = newOrganizationlist;
    this.organizatioListFunction();
  }

  ngOnInit(): void {
    this.palletTypeAddEditForm = this.formBuilder.group({
      organizationName: [this.palletTypeData.organizationId || this.organizationlist[0] || null],
      palletName: [this.palletTypeData.name || '', Validators.required],
      description: [this.palletTypeData.description || ''],
      mass: [this.palletTypeData.mass || 0, Validators.required],
    });
    this.setFormData();
  }

  onClose() {
    this.modal.close();
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  async organizatioListFunction() {
    await this.organizationlist?.map((item: any) => {
      if (item.id == this.palletTypeData.organizationId) {
        return (this.selectOrganization = item);
      }
    });
  }
  setFormData() {
    this.palletTypeAddEditForm.patchValue({ organizationName: this.selectOrganization });
  }

  onSave() {
    this.submitted = true;
    if (this.palletTypeAddEditForm.invalid) {
      return;
    }
    const savePalletTypeData = {
      palletTypeId: this.palletTypeData.palletTypeId || 0,
      name: this.palletTypeAddEditForm.controls['palletName'].value,
      description: this.palletTypeAddEditForm.controls['description'].value,
      mass: this.palletTypeAddEditForm.controls['mass'].value,
      organizationId:
        this.palletTypeAddEditForm.controls['organizationName'].value?.name == 'All organization' ||
        this.palletTypeAddEditForm.controls['organizationName'].value?.name == undefined
          ? null
          : this.palletTypeAddEditForm.controls['organizationName'].value?.id,
    };
    this.saveNewPalletTypeEvent.emit(savePalletTypeData);
  }
}
